export enum DeliveryMethods {
  /**
   * Самовывоз
   */
  PICKUP = 'pickup',

  /**
   * Доставка до ТК
   */
  DELIVERY_TC = 'delivery_tc',

  /**
   * Доставка до ТК
   */
  DELIVERY_CLIENT = 'delivery_client',
}

export enum SelfDeliveryMethods {
  /**
   * Самовывоз собственными силами
   */
  SELF_PICKUP = 'self_pickup',

  /**
   * Самовывоз транспортной компанией
   */
  TC_PICKUP = 'tc_pickup',
}

export enum ReceivingMethods {
  /**
   * До терминала
   */
  TO_TERMINAL = 'to_terminal',

  /**
   * Доставка до двери
   */
  TO_DOOR = 'to_door',
}

export enum TcDeliveryTypes {
  /**
   * Авиа
   *
   */
  AVIA = 'avia',

  /**
   * Авто
   */
  AUTO = 'auto',

  /**
   * ЖД
   */
  ZHD = 'zhd',

  /**
   * Экспресс
   */
  EXPRESS = 'express',

  /**
   * Морской
   */
  MARINE = 'marine',

  /**
   * Речной
   */
  RIVER = 'river',
}

export const DeliveryMethodsTranslate: Record<string, string> = {
  [DeliveryMethods.PICKUP]: 'Самовывоз',
  [DeliveryMethods.DELIVERY_TC]: 'Доставка до ТК',
  [DeliveryMethods.DELIVERY_CLIENT]: 'Доставка до клиента',
};

export const SelfDeliveryMethodsTranslate: Record<string, string> = {
  [SelfDeliveryMethods.SELF_PICKUP]: 'Собственными силами',
  [SelfDeliveryMethods.TC_PICKUP]: 'Транспортная компания',
};

export const ReceivingMethodsTranslate: Record<string, string> = {
  [ReceivingMethods.TO_TERMINAL]: 'До терминала',
  [ReceivingMethods.TO_DOOR]: 'До двери',
};

export const TcDeliveryTypesTranslate: Record<string, string> = {
  [TcDeliveryTypes.AVIA]: 'Авиа',
  [TcDeliveryTypes.AUTO]: 'Авто',
  [TcDeliveryTypes.EXPRESS]: 'Экспересс',
  [TcDeliveryTypes.MARINE]: 'Морской',
  [TcDeliveryTypes.RIVER]: 'Речной',
  [TcDeliveryTypes.ZHD]: 'ЖД',

};

export const delivery_methods_select = Object.keys(DeliveryMethodsTranslate).map((f: string) => ({
  text: DeliveryMethodsTranslate[f],
  value: f,
}));

export const self_delivery_methods_select = Object.keys(SelfDeliveryMethodsTranslate).map(
  (f: string) => ({ text: SelfDeliveryMethodsTranslate[f], value: f }),
);

export const receiving_methods_select = Object.keys(ReceivingMethodsTranslate).map((f: string) => ({
  text: ReceivingMethodsTranslate[f],
  value: f,
}));
